<div [ngClass]="[colour]" [appStoryblok]="_editable">
  <div class="container-xl container-top">
    <div class="row">
      <div
        class="col d-flex align-items-center justify-content-center justify-content-lg-between"
      >
        <h3 *ngIf="title" class="display-1 mb-0">
          {{ title }}
          <svg
            class="stroke"
            xmlns="http://www.w3.org/2000/svg"
            width="133"
            height="10"
            viewBox="0 0 133 10"
            fill="none"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M129.639 6.15841C94.7324 3.76332 48.6294 5.39204 4.92808 9.84521C-0.972013 10.3103 -1.82826 5.8109 10.548 4.65072C52.3982 0.727576 96.3002 -0.664851 129.548 1.61717C131.206 1.76723 132.427 2.64414 132.308 4.4079C132.188 6.17166 131.295 6.30296 129.639 6.15841Z"
              fill="#FBC5CD"
            />
          </svg>
        </h3>
      </div>
      <div
        class="col d-none d-lg-flex justify-content-end"
        *ngIf="link && link_text"
      >
        <a class="btn btn-lg" [ngClass]="[link_style]" [storyblokLink]="link">{{
          link_text || "Shop All"
        }}</a>
      </div>
    </div>
  </div>
  <div class="container-xl gx-0 collection mb-5" *ngIf="products.length > 0">
    <app-carousel [options]="options">
      <div class="px-1 action" *ngFor="let product of products">
        <app-collection-item
          [product]="product"
          [routerLink]="['/products/', product.handle]"
        ></app-collection-item>
      </div>
    </app-carousel>
  </div>
  <div class="container-xl container-bottom" *ngIf="link && link_text">
    <div class="row">
      <div class="d-flex d-lg-none">
        <a
          class="btn btn-lg mx-auto"
          [ngClass]="[link_style]"
          [storyblokLink]="link"
          >{{ link_text || "Shop All" }}</a
        >
      </div>
    </div>
  </div>
</div>
